export default "__VITE_ASSET__B1nB6SP$__"